module.exports = __webpack_public_path__ + "static/media/Lato-Italic.4ffc48d0.ttf";